import { createReducer, on } from "@ngrx/store";
import { onLoadableError, onLoadableLoad, onLoadableSuccess, toLoadableWrapper } from "../../models";
import { DeviceActions } from "./device.actions"
import { IDeviceState, initialDeviceState } from "./device.states"
import { IDevice } from "../../models/device.interface";
import { UserActions } from "../user/user.actions";

export function doesDeviceExist(device: any) {
    if (device != undefined || device != null) {
        return false;
    }

    return true;
}

function add_keeper(state: IDeviceState, device: IDevice): IDeviceState {
    let devices = [...state.keepers.items]
    if (doesDeviceExist(device) == true) {
        devices.push(toLoadableWrapper(device))
    }
    return {
        ...state,
        keepers: { ...state.keepers, items: devices, timestamp: null },
    }
}

export const deviceReducer = createReducer(
    initialDeviceState,
    on(DeviceActions.loadKeepers, (state, { useCache }) => ({
        ...state,
        keepers: onLoadableLoad({
            ...state.keepers,
            items: useCache && state.keepers.items?.length > 0 ? state.keepers.items : []
        })
    })),
    on(DeviceActions.loadKeepersSuccess, (state, { devices, timestamp }) => {
        return {
            ...state,
            keepers: onLoadableSuccess({ ...state.keepers, items: devices.map(e => toLoadableWrapper(e)), timestamp: timestamp })
        }
    }),
    on(DeviceActions.loadKeepersFailure, (state, { error }) => ({ ...state, keepers: onLoadableError({ ...state.keepers }, error) })),
    on(DeviceActions.addKeeper, (state, { device }) => add_keeper(state, device)),

    on(UserActions.logout, _ => ({ ...initialDeviceState })),
)
